import styled from 'styled-components';

export const LogoutContainer = styled.div`
  padding: 0.5rem 1rem 2rem 1rem;
`;
